import { useContext, useEffect, useState } from 'react';
// 组件
import { LockOutlined } from '@ant-design/icons';
import { Modal, Form, Input, message, Space, Spin, } from 'antd';
// 方法
import { login_web_getLoginInfo_api } from '../../../../api/login';
import LayoutContext from '../../../../PageLayout/context/LayoutContext'
import { renderEnumName } from '../../../../utils/renderUtils';
import { checkPasswordLevel, passwordEncryption } from '../../../../utils/loginUtils';
import { responseError } from '../../../../utils/messageUtils';
// 常量
import { PASSWORD_STRENGTH } from '../../../../constants/dict.enum';
import { SUCCESS_STATUS_CODE } from '../../../../constants/constant';

interface IPasswordInitInfo {
	publicKey: string;
	passwordMinLevel: number;
};
/** 修改密码 */
const ChangePassword = () => {
	const [loading, setLoading] = useState<boolean>(false);
	const [passwordLevel, setPasswordLevel] = useState<number>(0); // 密码强度等级
	const [passwordInfo, setPasswordInfo] = useState<IPasswordInitInfo>(); // 初始化信息
	const [form] = Form.useForm();
	const { global, dispatch } = useContext(LayoutContext);
	useEffect(() => {
		if (global.changePassword && !passwordInfo) {
			setLoading(true);
			login_web_getLoginInfo_api().then(res => {
				if (res.code === SUCCESS_STATUS_CODE) {
					const data = res.data;
					const { publicKey, strengthGrade = 1 } = data;
					setPasswordInfo({
						publicKey,
						passwordMinLevel: strengthGrade,
					});
				}
			}).finally(() => {
				setLoading(false);
			});
		}
  }, [global.changePassword]);
	/** 确认修改 */
	const handleOk = async () => {
		if (!passwordInfo) {
			responseError('初始化信息加载失败');
			return;
		}
		try {
			const data = await form.validateFields();
			const { oldPassword, newPassword, } = data;
			const publicKey = passwordInfo?.publicKey;
			const params = {
				oldPassword: passwordEncryption(oldPassword, publicKey),
				newPassword: passwordEncryption(newPassword, publicKey),
				strengthGrade: passwordLevel,
			};
			dispatch('changePassword', {
				data: params,
				onSuccess: (res: any) => {
					message.success(res.message);
				},
			});
		} catch (e) {}
	};
	/** 关闭弹窗 */
	const handleCancel = () => {
    dispatch('changeGlobal', { changePassword: false });
	};

	return (
		<Modal
			title="修改密码"
			open={global.changePassword}
			onOk={handleOk}
			onCancel={handleCancel}
			width={460}
		>
			<Spin spinning={loading}>
				<Form
					form={form}
					name="changePassword"
					labelCol={{ span: 6 }}
    			wrapperCol={{ span: 18 }}
				>
					<Form.Item
						label="旧密码"
						name="oldPassword"
						rules={[{ required: true, message: '请输入旧密码' }]}
					>
						<Input.Password
							prefix={<LockOutlined />}
							type="password"
							placeholder="旧密码"
						/>
					</Form.Item>
					<Form.Item label="新密码" required>
						<Space style={{ justifyContent: 'space-between', width: '100%'}}>
							<Form.Item
								name="newPassword"
								noStyle
								rules={[
									{
										required: true,
										message: '请输入新密码',
									},
									() => ({
										validator(_, value) {
											if (!passwordInfo?.passwordMinLevel || !value) return Promise.resolve();
											const currentLevel = checkPasswordLevel(value);
											setPasswordLevel(currentLevel)
											if (!value || currentLevel > passwordInfo.passwordMinLevel) {
												return Promise.resolve();
											}
											return Promise.reject(new Error('密码强度过低'));
										},
									}),
								]}
							>
								<Input.Password
									prefix={<LockOutlined />}
									type="password"
									placeholder="新密码"
								/>
							</Form.Item>
							<div className={`password-level${passwordLevel ? ' level-' + passwordLevel : ''}`}>
								<span className='password-level-bg'></span>
								<span className='password-level-text'>
									{passwordLevel ? renderEnumName(passwordLevel, PASSWORD_STRENGTH) : ''}
								</span>
							</div>
						</Space>
					</Form.Item>
					<Form.Item
						label="确认密码"
						name="confirmNewPassword"
						validateTrigger='onBlur'
						rules={[
							{
								required: true,
								message: '请输入确认密码',
							},
							({ getFieldValue }) => ({
								validator(rule, value) {
									if (!value || getFieldValue('newPassword') === value) {
										return Promise.resolve();
									}
									return Promise.reject('两次输入密码不一致');
								},
							}),
						]}
					>
						<Input.Password
							prefix={<LockOutlined />}
							type="password"
							placeholder="确认密码"
						/>
					</Form.Item>
				</Form>
			</Spin>
			
		</Modal>
	);
};

export default ChangePassword;
